import {makeAutoObservable} from "mobx";
import {ApiAdvertisingService} from "../../../shared/api";


class AdvertisingModel {
  slides = []

  constructor() {
    makeAutoObservable(this)
  }

  setSlides(slides) {
    this.slides = slides
  }

  async fetch() {
    try {
      const {data} = await ApiAdvertisingService.fetch()
      this.setSlides(data)
    } catch (err) {
      console.log(err)
    }
  }

  async create(slideInfo) {
    try {
      const response = await ApiAdvertisingService.create(slideInfo)
      return response
    } catch (err) {
      console.log(err)
    }
  }

  async update(slideId, slideInfo) {
    try {
      const response = await ApiAdvertisingService.update(slideId, slideInfo)
      return response
    } catch (err) {
      console.log(err)
    }
  }

  async delete(slideId) {
    const response = await ApiAdvertisingService.delete(slideId)
    return response
  }
}

export const advertisingModel = new AdvertisingModel()
